export default "__VITE_ASSET__CekysWw$__"